export abstract class KostDataImportApi {
  constructor(protected readonly _baseUrl: string) {}

  public abstract index(): string;

  public abstract byId(id: string): string;
}
